import React from "react";
import Wrapper from "../../components/wrapper";
import { Layout, Button } from "antd";
import verticalseparation from "../../assets/images/verticalseparation.png";
import downloadicon from "../../assets/images/downloadicon.png";
import '../styling/usermanagement.scss';
const { Content } = Layout;
//function to show the User Management page for Admins
const UserManagement = () => {
    return (
        <Wrapper heading={"12"} innerHeading={"10"}>
            <Content
                className="user-management-content"
            >
                <div className="page-headers">
                    <div className="main-heading">
                        Add/Remove member from the toolkit
                    </div>
                    <div className="second-heading">
                        Select the type of role you want to assign to New Member
                    </div>
                    <div className="buttons-group">
                        <span className="admin-button">
                            <Button type="custom" onClick={() => window.open(process.env.REACT_APP_ADMIN_LINK)}>
                                <p style={{ textDecorationLine: 'underline', marginTop: '7px' }}>Admin</p>
                            </Button>
                        </span>
                        <span className="alldataset-button">
                            <Button type="custom" onClick={() => window.open(process.env.REACT_APP_ALL_DATASET_LINK)}>
                                <p style={{ textDecorationLine: 'underline', marginTop: '7px' }}>All Dataset</p>
                            </Button>
                        </span>
                        <span className="nielsen-button">
                            <Button type="custom" onClick={() => window.open(process.env.REACT_APP_NIELSEN_LINK)}>
                                <p style={{ textDecorationLine: 'underline', marginTop: '7px' }}>Nielsen</p>
                            </Button>
                        </span>
                        <span className="epos-button">
                            <Button type="custom" onClick={() => window.open(process.env.REACT_APP_EPOS_LINK)}>
                                <p style={{ textDecorationLine: 'underline', marginTop: '7px' }}>EPOS</p>
                            </Button>
                        </span>
                        <span className="details-button">
                            <Button type="getguide"  onClick={() => window.open(process.env.REACT_APP_UM_GUIDE_LINK)}>
                                <div style={{ display: 'inline-flex' }}>
                                    <img src={downloadicon} style={{ width: '13.5px', height: '13.5px', marginTop: '9px', marginLeft: '-8.5px', marginRight: '7.5px' }} />
                                    <p style={{ marginTop: '7px' }}>Get Detailed Guide</p>
                                </div>
                            </Button>
                        </span>
                    </div>
                    <div className="page-contents">
                        <div className="add-member">
                            <div className="title">Add Member:</div>
                            <div className="steps-to-follow">
                                <p>Steps to follow:</p>
                                <p>1. Click on Add Members</p>
                                <p>2. Search for by member name/ Email Id, you can add multiple members here</p>
                                <p>3. Click Select to add the member(s) to the list</p>
                                <p>4. Click on Refresh to get the name of newly added member(s) to get listed</p>
                            </div>
                        </div>
                        <div className="divider-line1">
                            <img src={verticalseparation} />
                        </div>
                        <div className="remove-member">
                            <div className="title">Remove Member:</div>
                            <div className="steps-to-follow">
                                <p>Steps to follow:</p>
                                <p>1. Select name of member(s) to be removed</p>
                                <p>2. Click on the remove on the top</p>
                                <p>3. Member will be removed from the access list</p>
                            </div>
                        </div>
                        <div className="divider-line2">
                            <img src={verticalseparation} />
                        </div>
                        <div className="download-list">
                            <div className="title">Download List of Members:</div>
                            <div className="steps-to-follow">
                                <p>Steps to follow:</p>
                                <p>1. Select Bulk Operations, and select Download Members</p>
                                <p>2. You will get option to generate download CSV on right</p>
                                <p>3. Click Start to get the download link generated</p>
                                <p>4. Once completed you will get option of file is Ready! Click here to download</p>
                                <p>5. Click to get the CSV files of the same</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </Wrapper >
    );
}

export default UserManagement;